import authorizedRequest, { ApiRequestError } from './api';

const normalizeBusinessId = (value) => String(value || '').trim();

export const workspaceHeaders = (businessId, headers = {}) => {
  const normalizedId = normalizeBusinessId(businessId);
  if (!normalizedId) {
    throw new ApiRequestError({
      code: 'WORKSPACE_REQUIRED',
      message: 'Select a workspace before continuing.',
      status: 400,
    });
  }
  // The active-business header itself is attached by the request interceptor
  // in axiosConfig.js; this only validates that a workspace is selected.
  return { ...headers };
};

export const workspaceApiPath = (businessId, resource = '') => {
  const normalizedId = normalizeBusinessId(businessId);
  if (!normalizedId) {
    throw new ApiRequestError({
      code: 'WORKSPACE_REQUIRED',
      message: 'Select a workspace before continuing.',
      status: 400,
    });
  }
  const suffix = String(resource || '').replace(/^\/+/, '');
  return `/api/businesses/${encodeURIComponent(normalizedId)}${suffix ? `/${suffix}` : ''}`;
};

export const authorizedWorkspaceRequest = ({
  businessId,
  resource,
  headers,
  ...request
}) => authorizedRequest({
  ...request,
  url: workspaceApiPath(businessId, resource),
  headers: workspaceHeaders(businessId, headers),
});

export const createLinkedAbortController = (...signals) => {
  const controller = new AbortController();
  const sources = signals.filter(Boolean);
  const abort = () => controller.abort();
  sources.forEach((signal) => {
    if (signal.aborted) abort();
    else signal.addEventListener('abort', abort, { once: true });
  });
  return {
    controller,
    dispose: () => sources.forEach((signal) => signal.removeEventListener('abort', abort)),
  };
};

export const isCanceledRequest = (error, signal = null) =>
  signal?.aborted || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';
